"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EASASPermission = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.EASASPermission = {
    ADMIN: 'ADMIN',
    SUPER_USER: 'SUPER_USER',
    USE_CRM: 'USE_CRM',
    USE_TASKER: 'USE_TASKER',
    USER_MANAGEMENT: 'USER_MANAGEMENT',
    COMPANY_INITIAL_SETUP: 'COMPANY_INITIAL_SETUP',
    USE_DATA_SERVICES: 'USE_DATA_SERVICES',
    VIEW_DATA_SERVICES: 'VIEW_DATA_SERVICES',
    VIEW_DATA_SERVICE_CHARTS: 'VIEW_DATA_SERVICE_CHARTS',
    VIEW_DATA_SERVICE_DASHBOARD: 'VIEW_DATA_SERVICE_DASHBOARD',
    VIEW_DATA_SERVICE_EQUIPMENT: 'VIEW_DATA_SERVICE_EQUIPMENT',
    VIEW_DATA_SERVICE_DATA: 'VIEW_DATA_SERVICE_DATA',
    CUSTOMIZE_DATA_SERVICE_DASHBOARD: 'CUSTOMIZE_DATA_SERVICE_DASHBOARD',
    VIEW_GIS_MAP: 'VIEW_GIS_MAP',
    MEASUREMENT_DEVICE_MANAGER: 'MEASUREMENT_DEVICE_MANAGER',
    DATASET_DATA_PUSH: 'DATASET_DATA_PUSH',
    VIEW_MEASUREMENT_CONNECTION: 'VIEW_MEASUREMENT_CONNECTION',
    EDIT_MEASUREMENT_CONNECTION: 'EDIT_MEASUREMENT_CONNECTION',
    CREATE_MEASUREMENT_CONNECTION: 'CREATE_MEASUREMENT_CONNECTION',
    DELETE_MEASUREMENT_CONNECTION: 'DELETE_MEASUREMENT_CONNECTION',
    METER_TEMPLATES_VIEW: 'METER_TEMPLATES_VIEW',
    METER_TEMPLATES_EDIT: 'METER_TEMPLATES_EDIT',
    METER_TEMPLATES_CREATE: 'METER_TEMPLATES_CREATE',
    METER_TEMPLATES_DELETE: 'METER_TEMPLATES_DELETE',
    METER_TEMPLATES_ALL: 'METER_TEMPLATES_ALL',
    APPLICATIONS_VIEW: 'APPLICATIONS_VIEW',
    APPLICATIONS_UPLOAD_UPDATES: 'APPLICATIONS_UPLOAD_UPDATES',
    APPLICATIONS_DELETE_UPDATES: 'APPLICATIONS_DELETE_UPDATES',
    APPLICATIONS_MANAGE_UPDATES: 'APPLICATIONS_MANAGE_UPDATES',
    APPLICATIONS_CREATE_APPLICATIONS: 'APPLICATIONS_CREATE_APPLICATIONS',
    APPLICATIONS_EDIT_APPLICATIONS: 'APPLICATIONS_EDIT_APPLICATIONS',
    APPLICATIONS_DELETE_APPLICATIONS: 'APPLICATIONS_DELETE_APPLICATIONS',
    APPLICATIONS_MANAGE_APPLICATIONS: 'APPLICATIONS_MANAGE_APPLICATIONS',
    APPLICATIONS_ALL: 'APPLICATIONS_ALL',
    LICENCE_MANAGER: 'LICENCE_MANAGER',
    PRODUCT_TEMPLATE_ADMIN: 'PRODUCT_TEMPLATE_ADMIN',
    PRODUCT_TEMPLATE_MANAGER: 'PRODUCT_TEMPLATE_MANAGER',
    PRODUCT_TEMPLATE_SIGNATURE_OVERRIDE: 'PRODUCT_TEMPLATE_SIGNATURE_OVERRIDE',
    PRODUCT_TEMPLATE_DATA_DELETE_MULTIPLE: 'PRODUCT_TEMPLATE_DATA_DELETE_MULTIPLE',
    PRODUCT_TEMPLATE_DATA_DELETE_ALL: 'PRODUCT_TEMPLATE_DATA_DELETE_ALL',
    JWT_GENERATE_FOR_OTHER_USER: 'JWT_GENERATE_FOR_OTHER_USER',
    JWT_ALL: 'JWT_ALL',
    MANAGE_INTERNAL_JOBS: 'MANAGE_INTERNAL_JOBS',
    AIRFLOW_VIEW: 'AIRFLOW_VIEW',
    AIRFLOW_EDIT: 'AIRFLOW_EDIT',
    AIRFLOW_REST: 'AIRFLOW_REST',
    AIRFLOW_MANAGER: 'AIRFLOW_MANAGER',
    AIRFLOW_ADMIN: 'AIRFLOW_ADMIN',
    INSTANT_JOB_ENQUEUE: 'INSTANT_JOB_ENQUEUE',
    INSTANT_JOB_ADMIN: 'INSTANT_JOB_ADMIN',
    SERVER_MANAGEMENT: 'SERVER_MANAGEMENT',
    TESTER: 'TESTER',
    ALERTMANAGER_NOTIFIER: 'ALERTMANAGER_NOTIFIER',
    LOGGING_SERVICE_REST: 'LOGGING_SERVICE_REST',
    MIGRATION_COMPANY_ID_REFERENCE_CONVERT: 'MIGRATION_COMPANY_ID_REFERENCE_CONVERT',
    PUBLIC_FILES_EDIT: 'PUBLIC_FILES_EDIT',
    COMPANY_FILES_VIEW: 'COMPANY_FILES_VIEW',
    COMPANY_FILES_EDIT: 'COMPANY_FILES_EDIT'
};
//# sourceMappingURL=easaspermission.js.map